import React, {  } from 'react';
import CircularTickIcon from 'src/assets/svg/circular-tick-icon';
import styles from './third-party-login-component.module.scss';
interface IThirdPartyVerificationSuccessProps {
	clientName: string;
	isAlreadyVerified: boolean;
}

const SuccessScreen: React.FC<IThirdPartyVerificationSuccessProps> = ({
	clientName,
	isAlreadyVerified
}) => {	

	return (
		<>
			<CircularTickIcon />
			<div className={styles.headerText}>Successfully added!</div>
			{isAlreadyVerified ? (
				<div className={styles.infoText}>
					You have authenticated your identity and are an <br/>authorized user of{' '}
					<span className={styles.boldText}>{clientName}’s</span> client portal.
				</div>
			) : (
				<>
					<div className={styles.infoText}>
						You have been successfully added as an authorized user <br /> of{' '}
						<span className={styles.boldText}>{clientName}’s</span> client portal.
					</div>
					<div className={styles.infoText + ' mt-4 mb-4'}>
						You will receive a separate email with an access link when <br /> <span>{clientName}</span> requests you
						access their client portal.
					</div>
					<div className={styles.infoText}>To exit, simply close this browser tab.</div>
				</>
			)}
		</>
	);
};

export default SuccessScreen;
